// removed by extract-text-webpack-plugin
module.exports = {"share-button-container":"ezTR0","share-button":"_1j3xG","twitter":"Euwq1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareModal/TwitterShareButton.scss
// module id = ./src/components/ShareModal/TwitterShareButton.scss
// module chunks = 4